import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"

class CardStatus extends Component {
  render() {
    return (
      <div className="col-lg-3 col-md-6 col-sm-6">
        <div className="card card-stats">
          <div
            className="card-header"
            data-background-color={this.props.backgroundColor}
          >
            <i className="material-icons">{this.props.icon}</i>
          </div>
          <div style={{ height: 140 }} className="card-content">
            <p
              id="p_categorys"
              className="category"
              style={{
                fontWeight: "bold"
              }}
            >
              {this.props.category}
            </p>
            <h3 id="h3_value" className="title">{this.props.data}</h3>
          </div>
          <div className="card-footer">
            <div className="stats">
              <i className="material-icons text-danger">
                {this.props.linkIcon}
              </i>
              <Link to={this.props.link}>{this.props.linkLabel} </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(CardStatus)



// WEBPACK FOOTER //
// ./src/components/CardStatus.js